// Centralized onboarding module definitions and helpers

export type ModuleKey = 'welcome' | 'chat' | 'wiki' | 'review' | 'write' | 'dashboard' | 'dataLibrary';

export type OnboardingModule = {
  key: ModuleKey;
  title: string;
  checklistTitle?: string;
  route?: string;
  requiresChampion?: boolean;
  minutes?: number;
};

export const ONBOARDING_MODULES: OnboardingModule[] = [
  {
    key: 'welcome',
    title: 'Quick Tips',
    checklistTitle: 'Install CompliMind App',
    route: '/home',
    minutes: 1
  },
  {
    key: 'chat',
    title: 'Chat Assistant',
    checklistTitle: 'Ask your first question',
    route: '/chat',
    minutes: 5
  },
  {
    key: 'review',
    title: 'Review Assistant',
    checklistTitle: 'Review a Policy',
    route: '/review',
    minutes: 7
  },
  {
    key: 'write',
    title: 'Writing Assistant',
    checklistTitle: 'Write meeting minutes',
    route: '/write',
    minutes: 7
  },
  {
    key: 'wiki',
    title: 'Wiki',
    checklistTitle: 'Explore the Wiki',
    route: '/wiki',
    minutes: 3
  },
  {
    key: 'dataLibrary',
    title: 'Data Library',
    checklistTitle: 'Upload your first document',
    route: '/admin?tab=data-library',
    minutes: 3
  },
  {
    key: 'dashboard',
    title: 'Dashboard',
    checklistTitle: "View your Organisation's Performance",
    route: '/dashboard',
    requiresChampion: true,
    minutes: 2
  }
];

export function isOnboardingModuleCompleted(key: ModuleKey): boolean {
  try {
    return localStorage.getItem(`innex-onboarding-module-${key}-completed`) === 'true';
  } catch {
    return false;
  }
}
